<template>
  <menu-item v-for="(item, index) in topMenu" :key="index" :item="item" @click="onItemClick" />
  <v-spacer />
  <menu-item v-for="(item, index) in bottomMenu" :key="index" :item="item" @click="onItemClick" />
  <template v-if="showProfileMenu">
    <div class="default-layout-menu__title mt-4">
      <span class="paragraph-xs text-ordinary"><b>Личный кабинет</b></span>
    </div>
    <menu-item v-for="(item, index) in profileMenu" :key="index" :item="item" @click="onItemClick" />
  </template>
</template>

<script setup lang="ts">
import { computed, toRef } from 'vue';
import { useRoute } from 'vue-router';
import type { MenuItemType } from '@/core/types/components/components';
import { useServices } from '@/core/composables/services';
import MenuItem from '@/core/layouts/components/MenuItem.vue';
import { RouteNames } from '@/core/plugins/router/routeNames';
import { PermissionTarget } from '@/graphql/generated';

defineProps<{
  showProfileMenu?: boolean;
}>();

const emit = defineEmits<{
  (event: 'itemClick'): void;
}>();

const $route = useRoute();
const { $auth } = useServices();

const topMenu = computed<MenuItemType[]>(() => [
  {
    title: 'Объекты размещения',
    icon: 'hotel',
    lockedIcon: 'hotelLock',
    to: {
      name: RouteNames.Home,
    },
    active: $route.name === RouteNames.ObjectCreate,
    permissions: [PermissionTarget.AccommodationObjects],
  },
  {
    title: 'Юридические лица',
    icon: 'briefcase',
    lockedIcon: 'briefcaselLock',
    to: {
      name: RouteNames.Legals,
    },
    active: $route.name === RouteNames.LegalDetail || $route.name === RouteNames.LegalCreate,
    permissions: [PermissionTarget.Legals],
  },
  {
    title: 'Документы',
    icon: 'documents',
    lockedIcon: 'documentsLock',
    to: {
      name: RouteNames.Documents,
    },
    permissions: [PermissionTarget.Documents],
  },
  {
    title: 'Пользователи',
    icon: 'users3',
    lockedIcon: 'usersLock',
    to: {
      name: RouteNames.Users,
    },
    active: $route.name === RouteNames.User,
    permissions: [PermissionTarget.Users],
  },
]);

const bottomMenu: MenuItemType[] = [
  {
    title: 'Поддержка',
    icon: 'support',
    to: {
      name: RouteNames.Support,
    },
  },
];

const logout = async () => {
  await $auth.logout();
};

const onItemClick = () => {
  emit('itemClick');
};

const profileMenu = toRef<() => MenuItemType[]>(() => [
  {
    title: 'Профиль',
    icon: 'profile',
    to: {
      name: RouteNames.Profile,
    },
  },
  {
    title: 'Выход',
    icon: 'exit',
    action: logout,
  },
]);
</script>

<style scoped lang="scss">
.default-layout-menu {
  &__title {
    margin-bottom: 4px;
    padding-left: 10px;

    @include lg-and-down {
      padding-left: 0;
    }

    @include xs {
      padding-left: 16px;
    }
  }
}
</style>
